import { format } from 'date-fns';


export function formatDate_1(dateInput: string | Date | undefined): string {
  if (!dateInput) return '-';
  return new Date(dateInput).toLocaleDateString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric'
  });
}

export function formatDate_2 (dateString: string | Date | null) {
  if (!dateString) return 'Never';
  try {
    return format(new Date(dateString), 'MMM d, yyyy');
  } catch {
    return 'Invalid date';
  }
};

export function formatDate_3 (dateString: string | Date | null) {
  if (!dateString) return 'Never';
  try {
    return format(new Date(dateString), 'yyyy-MM-dd HH:mm:ss');
  } catch {
    return 'Invalid date';
  }
};

/**
 * Formats seconds into a MM:SS.ms format.
 * @param seconds - The time in seconds.
 */
export function formatTime_4(seconds: number): string {
  if (isNaN(seconds) || seconds < 0) return '00:00.000'
  const date = new Date(0)
  date.setUTCSeconds(seconds)
  const timeString = date.toISOString().substring(14, 23)
  const minutes = String(Math.floor(seconds / 60)).padStart(2, '0')
  return `${minutes}:${timeString.substring(3)}`
}

export function glowOnce(selector: string, duration = 1000) {
  const el = document.querySelector<HTMLElement>(selector)
  if (!el) return

  // Ensure base class is there for transition
  el.classList.add('glow-target')

  // Add glow state
  el.classList.add('v-glow-once-active2')

  // Remove glow state after duration (will transition smoothly to base)
  setTimeout(() => {
    el.classList.remove('v-glow-once-active2')
  }, duration)
}